import Button from 'components/base/Button';
import AuthSimpleLayout from 'layouts/AuthSimpleLayout';
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { FormEvent, useState } from 'react';
import { useAuth } from 'providers/AuthProvider';
import { adminLogin } from 'features/admin/adminApi';

const AdminLoginPage = () => {
  const navigate = useNavigate();
  const { login: loginWithSession } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

 const handleSubmit = async (
  event: FormEvent<HTMLFormElement>
) => {
  event.preventDefault();

  setErrorMessage('');
  setIsLoading(true);

  try {
    const data = await adminLogin({
      email,
      password
    });

    const session = {
      token: data.token,
      user: data.user
    };

    // Verify admin role
    if (session.user.role !== 'admin') {
      setErrorMessage(
        'Admin access required'
      );

      return;
    }

    loginWithSession(session);

    navigate('/dashboard', {
      replace: true
    });
  } catch (error) {
    setErrorMessage(
      error instanceof Error
        ? error.message
        : 'Login failed'
    );
  } finally {
    setIsLoading(false);
  }
};

  return (
    <AuthSimpleLayout>
      <div className="text-center mb-6">
        <h3 className="text-body-highlight">Admin Login</h3>
        <p className="text-muted">Access the admin dashboard</p>
      </div>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3 text-start">
          <Form.Label>Email</Form.Label>
          <Form.Control
            type="email"
            required
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="admin@example.com"
          />
        </Form.Group>

        <Form.Group className="mb-3 text-start">
          <Form.Label>Password</Form.Label>
          <Form.Control
            type="password"
            required
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Password"
          />
        </Form.Group>

        {errorMessage && (
          <div className="alert alert-danger py-2" role="alert">
            {errorMessage}
          </div>
        )}

        <Button
          type="submit"
          variant="primary"
          className="w-100 mb-3"
          disabled={isLoading}
        >
          {isLoading ? 'Logging in...' : 'Login'}
        </Button>

        <div className="text-center fs-9">
          <Link to="/auth/login">Login as Locum or Pharmacy</Link>
        </div>
      </Form>
    </AuthSimpleLayout>
  );
};

export default AdminLoginPage;
